<div class="row">
  <div *ngIf="fileErrors.length > 0">
    <div class="no-margin p-0" *ngFor="let combinedErrors of fileErrors; let index = index">
      <div class="col-sm-12 error-list">
        <mat-accordion>
          <mat-panel-title class="error-list fw-bold">
            {{ this.getErrors(combinedErrors, index) }}
            <div *ngIf="combinedErrors.errors.length > 0" class="error-list">
              <div class="row">
                <div class="col-2"></div>
                <div class="col-16">
                  <ul class="no-margin p-0" *ngFor="let error of combinedErrors.errors">
                    <li>{{ error }}</li>
                  </ul>
                </div>
              </div>
            </div>
          </mat-panel-title>
        </mat-accordion>
      </div>
    </div>
  </div>
</div>
